import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useDispatch, useSelector } from "react-redux";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box } from "@mui/material";
import apiRequest from '../../../../../utils/apiRequest';
import { USERS_ADDRESSES_GET } from '../../../../../apis';
import { handleChangeDataUserAddresses } from '../../../../../redux/actions/pages/user/addresses';
import { handleSetActiveAddress } from "../../../../../redux/actions/pages/user/user";
import { handleChangeDataModalAddAddress } from '../../../../../redux/actions/partials/modals/modalAddAddress';


const Addresses = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { isMobile } = useSelector(state => state.general);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);
	const { token } = useSelector(state => state.login);
	const { activeAddress } = useSelector(state => state.user);
	const { addresses } = useSelector(state => state.addresses);

	useEffect(() => {
        apiGetAddresses();
    }, [Addresses]);

    const apiGetAddresses = () => {
		if(! isBackdropLoading) {
			apiRequest({
			    dispatch,
			    endpoint: USERS_ADDRESSES_GET,
			    method: 'get',
			    token: token, 
			    onSuccess: (res) => {
			    	res.addresses.map((address, index) => {
			    		address.isPrimary = address.id == activeAddress?.id;
			    	});
			      	dispatch(handleChangeDataUserAddresses('addresses', res.addresses))
			    },
		  	});
		}
	};

	const handleSelectAddress = (addressId) => {
		const addressData = addresses.find(address => address.id === addressId);
		dispatch(handleSetActiveAddress(addressData));

		let newAddresses = addresses;
		newAddresses.map((address, index) => {
    		address.isPrimary = address.id == addressId;
    	});
      	dispatch(handleChangeDataUserAddresses('addresses', newAddresses))
	};

	const showModalAddAddress = () => {
		dispatch(handleChangeDataModalAddAddress('isOpen', true));
		setTimeout(() => dispatch(handleChangeDataModalAddAddress('isActive', true)), 0);
	};

	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

    return (
    	<>

    	{isMobile ?
    	<div className="lg:rounded-medium relative styles-Frame-profile-content mb-4 bg-neutral-000">
    		<div className="flex justify-between items-center lg:py-4 px-4">
    			<div className="break-words py-3 styles-ProfileCard-title-mobileHeader">
    				<div className="flex items-center grow">
    					<div className="flex shrink-0 ml-2 cursor-pointer" onClick={() => navigate(-1)} >
    						<ArrowForwardIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} />
    					</div>
    					<p className="grow text-h5 text-neutral-900 mb-0">
    						<span className="relative">آدرس ها</span>
    					</p>
    				</div>
    			</div>
    		</div>
    	</div>
    	:''}


    	<div className="lg:rounded-medium relative styles-Frame-profile-content mb-4 bg-neutral-000">
    		{!isMobile &&
				<div className="flex justify-between items-center lg:py-4 px-4">
					<div className="break-words py-3">
						<div className="flex items-center grow">
							<p className="grow text-h5 text-neutral-900 mb-0">
								<span className="relative">آدرس&zwnj;ها</span>
							</p>
						</div>
						<div className="mt-2 styles-Title-line styles-Title-line-red"></div>
					</div>
					<div onClick={showModalAddAddress} className="flex items-center cursor-pointer">
						<div className="f-flex">
							<AddIcon sx={{width: '24px', height: '24px', fill: 'rgb(231, 19, 61)'}} />
						</div>
						<div className="whitespace-nowrap text-[#E7133D] text-body1-strong mr-2">
							افزودن آدرس جدید
						</div>
					</div>
				</div>
			}
			<div className="px-5 lg:px-6">
				{ 
					addresses.map((address, key) => (
						<div key={key} onClick={() => handleSelectAddress(address.id)} className={`flex items-start px-4 py-3 rounded w-full transition-all ${address.isPrimary ? 'border-complete-secondary-700' : 'border-complete-200'} mb-3 cursor-pointer`} >
							<div className="flex items-start w-full">
								<div className="flex">
									<LocationOnIcon sx={{width: '24px', height: '24px', fill: `${address.isPrimary ? 'rgb(0, 142, 178)' : 'rgb(98, 102, 109)'}`}} />
								</div>
								<div className="ml-4 grow -mt-1">
									<p className="text-body-1 text-secondary-700 mb-0"></p>
									<p className="text-body-1 text-neutral-600 mb-0">
										<div>
											<div className={`${address.isPrimary? 'text-secondary-700' : 'text-body-1'}`}>
												{address.address}
											</div>
											<div>کد پستی: {toPersianDigits(address.postalCode)}</div>
											<div className="flex">
												<div>گیرنده: {address.receiverName}  </div>
												<div className="mr-0.5">
													<span> | {toPersianDigits(address.receiverMobile)} </span>
												</div>
											</div>
										</div>
									</p>
								</div>
								<div>
									<div>
										<button className="flex" type="button">
											<div className="flex outline-none">
												<MoreVertIcon sx={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}} />
											</div>
										</button>
									</div>
								</div>
							</div>
						</div>
					))
				}	
			</div>
		</div>


		<div className="fixed w-full left-0 bottom-14 flex justify-end lg:hidden pb-4 px-5">
			<button onClick={showModalAddAddress} className="font-iran-yekan flex items-center justify-between text-button-1 styles-FabButton styles-FabButton-primary px-4 py-3 px-4 shadow-fab-button whitespace-nowrap">
				<div className="flex items-center justify-content-center">
					<div className="ml-2">ثبت آدرس جدید</div>
					<div className="flex styles-FabButton-icon">
						<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-white)'}}>
							<use xlinkHref="#newAddress"></use>
						</svg>
					</div>
				</div>
			</button>
		</div>

		</>

    );
}

export default Addresses;